import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinConfidenceDropdownComponent extends Component {
  @service organisation;

  tippyInstance = null;

  get confidenceOptions() {
    if (this.args.type === 'Investment')
      return this.organisation.investmentConfidenceOptions;
    if (this.args.type === 'Return')
      return this.organisation.returnConfidenceOptions;
    return [];
  }

  @action
  handleConfidenceSelect(e) {
    this.args?.onSelect(e);
    this.tippyInstance.hide();
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }
}
